import { render, staticRenderFns } from "./ProjectStatisticsCard.vue?vue&type=template&id=a59ddd60"
import script from "./ProjectStatisticsCard.vue?vue&type=script&lang=js"
export * from "./ProjectStatisticsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports